module.exports = __webpack_public_path__ + "media/virtual-gallery/GalleryOfTheirOwn-e2443f16.jpg";